function rfq(){
    window.location.href = `${window.location.origin}/pages/contact?rfq=SBS+${collectionHandle.replace("servers", "")}`;
}

function selectTab(tab) {
    const tabs = ["namedBabyDescription", "cto-product-documentation", "cto-build-summary"];
    const buttons = ["namedBabyDescription-btn", "cto-product-documentation-btn", "cto-build-summary-btn"];
    
    tabs.forEach((id, index) => {
        document.getElementById(id).classList.toggle("selectedTab", id === tab);
        document.getElementById(id).classList.toggle("unselectedTab", id !== tab);
        document.getElementById(buttons[index]).classList.toggle("selectedTabBtn", id === tab);
    });
}

async function setupCTOContentResources(data) {
    var CTOContentResourcesContainer = document.querySelector('#CTOContentResourcesContainer');
    var resourceData = data;
    var resourceLink = resourceData.linkToResource;
    var resourceDescription = resourceData.description.content;

    var image = await fetchEntry("assets", resourceData.image.sys.id);
    await Promise.all([image]);
    var imageURL = image.fields.file.url.replace('//', 'https://');
    var imageDescription = image.fields.description;

    var parsedDescription = '';
 
    resourceDescription.forEach(node => {
        parsedDescription += parseRichText(node);
    });

    const resourceContainer = document.createElement('div');
    resourceContainer.classList.add('resourceContainer');

    const resourceImageContainer = document.createElement('div');
    resourceImageContainer.classList.add('resourceImageContainer');
    
    const resourceImage = document.createElement('img');
    resourceImage.src = imageURL + '?w=159';
    resourceImage.alt = imageDescription;
    resourceImage.classList.add('resourceImage');
    resourceImage.classList.add('lazyload');
    resourceImage.srcset = `
        ${imageURL}?w=159 159w,
        ${imageURL}?w=318 318w,
        ${imageURL}?w=300 480w,
        `;
    resourceImage.sizes = '(max-width: 159px) 159px, (max-width: 318px) 318px, (max-width: 480px) 480px';
    resourceImage.width = '159';
    resourceImage.height = '159';
    const resourceTitle = document.createElement('h3');
    resourceTitle.classList.add('resourceTitle');
    resourceTitle.innerHTML = resourceData.title;

    const resourceDescriptionContainer = document.createElement('div');
    resourceDescriptionContainer.classList.add('resourceDescriptionContainer');
    resourceDescriptionContainer.innerHTML = parsedDescription;

    const resourceLinkElem = document.createElement('a');
    resourceLinkElem.classList.add('resourceLink');
    resourceLinkElem.href = resourceLink;
    resourceLinkElem.title = resourceData.title;

    resourceImageContainer.appendChild(resourceImage);
    resourceLinkElem.appendChild(resourceImageContainer);
    resourceLinkElem.appendChild(resourceTitle);
    resourceLinkElem.appendChild(resourceDescriptionContainer);
    resourceContainer.appendChild(resourceLinkElem);
    CTOContentResourcesContainer.appendChild(resourceContainer);
}


function createTextElem(parent, asset, valueData = null){

    if (!document.getElementById(parent))return;
    const elemParent = document.getElementById(parent);

    if (asset && asset.entryType && asset.entryType !== undefined){
        const child = document.createElement("div");
        child.className = asset.entryType;

        if (asset.includeAssetTitleAsAHeader && asset.includeAssetTitleAsAHeader == true){
            const elemHeader = document.createElement("div");
            elemHeader.className = "kitTextHeader"
            elemHeader.innerText = asset.assetTitle;
            child.appendChild(elemHeader);
        }
        if (asset.includeAssetTitleAsAHeader && asset.includeAssetTitleAsASubHeader == true){
            const elemHeader = document.createElement("div");
            elemHeader.className = "kitTextSubHeader"
            elemHeader.innerText = asset.assetTitle;
            child.appendChild(elemHeader);
        }



        if (asset.text.content) {
          for (let index = 0; index < asset.text.content.length; index++) {
            const content = asset.text.content[index].content;
            for (let innerIndex = 0; innerIndex < content.length; innerIndex++) { // Renamed inner loop index to avoid conflicts
              if (content[innerIndex].value.includes("[Update Date]")) {
                content[innerIndex].value = content[innerIndex].value.replace("[Update Date]", valueData);
              }
            }
          }
        }
        
          

        child.innerHTML += richText(asset.text.content);

        if (asset.entryType.toLowerCase().includes("halfwidth")){
            if (!document.querySelector(".kitInnerParent" + asset.entryType)) {
                const innerParent = document.createElement("div");
                innerParent.className = "kitInnerParent" + asset.entryType;
                innerParent.appendChild(child);
                elemParent.appendChild(innerParent);
            } else {
                const innerParent = document.querySelector(".kitInnerParent" + asset.entryType);
                innerParent.appendChild(child);
            }
        } else {
            const innerParent = document.createElement("div");
            innerParent.className = "kitInnerParent" + asset.entryType;
            innerParent.appendChild(child);
            elemParent.appendChild(innerParent);
        }
    }

}

function processContentfulKitAsset(parent, asset, valueData = null){
    if (asset && asset.fields.entryType && asset.fields.entryType !== undefined){
        if (asset.fields.entryType.includes("Text") && !asset.fields.entryType.includes("specialText")){
            createTextElem(parent, asset.fields, valueData);
        }
    }

}

function removeSkeleton(elId) {
//  alert(elId);
  let el = document.getElementById(elId);
  let parent = el.parentNode;
  let childrenOfParent = parent.children;
  let removeParentClass = false;
  if(el && el.classList.contains('skeleton_text')){
    el.classList.remove('skeleton_text');
    for (let i = 0; i < childrenOfParent.length; i++){
      let child = childrenOfParent[i];
      if (child !== el && !child.classList.contains("skeleton_text")){
        removeParentClass = true;
      } 
    }
    if (removeParentClass){
      parent.classList.remove("loading-skeleton");
    }
  }
}

function formatTime(timeStr){
  let date = new Date(timeStr);
  const formattedTime = date.toLocaleDateString('en-US', {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
  return formattedTime;
}


async function processContentfulLazily(contentfulFields) {
    for (let [key, value] of Object.entries(contentfulFields)) {
        try {
          if (typeof value === 'string') {
                removeSkeleton(key)
                fillTitleText(value, `#${key}`);
            } else if (value && value.nodeType === 'document') {
                removeSkeleton(key);
                fillDescriptionText(richText(value.content), `#${key}`);
            } else if (isAssetLink(value)) {
                let img = await fetchImage(value);
                updateImage(key, img);
            } else if (key === "applicationIcons" && Array.isArray(value)) {
                for (let item of value) {
                   // let img = await fetchImage(item);
                   // createImage("hmgsBreak", img, key);
                }
            } else if (key === "keyIngredients" && Array.isArray(value)) {
                const ids = value.map(item => item.sys.id);
                const entriesData = await Promise.all(ids.map(id => fetchEntry("entries", id)));
                const ingredientDataPromises = entriesData.map((entry, index) => renderKeyIngredient(index, entry));
                const renderedIngredients = await Promise.all(ingredientDataPromises);
               for (let i = 0; i < value.length; i++) {
                  let ingredientData = await fetchEntry("entries", value[i].sys.id);
                   renderKeyIngredient(i, ingredientData);
                }
            } else if (key === "body1" && Array.isArray(value)) {
                const updatedDate = formatTime(contentfulFields.lastUpdated);
                const updatedDateEl = document.createElement("span");
                updatedDateEl.classList.add("green");
                updatedDateEl.innerText = "Passed " + updatedDate;
                for (let i = 0; i < value.length; i++) {
                    let valueData = await fetchEntry("entries", value[i].sys.id);
                    processContentfulKitAsset(key, valueData, updatedDateEl.outerHTML);
                    if (i === value.length -1){
                      document.getElementById("body1").classList.remove("skeleton_text");
                    }
                }
              }
           
            
        } catch (error) {
            console.warn(error);
        }
    }
}

function setupKeyIngredientsContainers() {
    const keyIngredientsContainer = document.getElementById("keyIngredients");
    if (!keyIngredientsContainer) return;

    if (!document.getElementById("keyIngredientsLeft")) {
        const containerLeft = document.createElement("div");
        containerLeft.id = "keyIngredientsLeft";
        containerLeft.className = "flCol w50";
        keyIngredientsContainer.appendChild(containerLeft);
    }

    if (!document.getElementById("keyIngredientsRight")) {
        const containerRight = document.createElement("div");
        containerRight.id = "keyIngredientsRight";
        containerRight.className = "flCol w50";
        containerRight.style.alignItems = "flex-end";
        keyIngredientsContainer.appendChild(containerRight);
    }
}

function isAssetLink(value) {
    return value && value.sys && value.sys.linkType === 'Asset';
}

async function fetchImage(assetLink) {
    return await fetchEntry("assets", assetLink.sys.id);
}


const renderedIngredients = new Set();

async function renderKeyIngredient(index, ingredientData) {
    const ingredientId = ingredientData.sys.id;
    if (renderedIngredients.has(ingredientId)) {
        return; 
    }

    renderedIngredients.add(ingredientId);

    const titleId = index === 0 ? 'firstKeyIngredientTitle' : index === 1 ? 'secondKeyIngredientTitle' : index === 2 ? 'thirdKeyIngredientTitle' : 'fourthKeyIngredientTitle';
    const descriptionId = index === 0 ? 'firstKeyIngredientDescription' : index === 1 ? 'secondKeyIngredientDescription' : index === 2 ? 'thirdKeyIngredientDescription' : 'fourthKeyIngredientDescription';
    const subDescriptionId = index === 0 ? 'firstKeyIngredientSubDescription' : index === 1 ? 'secondKeyIngredientSubDescription' : index === 2 ? 'thirdKeyIngredientSubDescription' : 'fourthKeyIngredientSubDescription';
    const ingredientSpan = document.createElement("span");
    ingredientSpan.className = "ingredient pipadding";

    const titleDiv = document.createElement("div");
    titleDiv.id = titleId;
    titleDiv.className = "ingredientTitle";
    titleDiv.textContent = ingredientData.fields.keyIngredientTitle || "";

    const descriptionDiv = document.createElement("div");
    descriptionDiv.id = descriptionId;
    descriptionDiv.className = "otfem";
    descriptionDiv.innerHTML = richText(ingredientData.fields.keyIngredientDescription.content);
    
    const subContainer = document.createElement("div");
    subContainer.className = "flRow";
    subContainer.classList.add("keySubContainer")

    const subDescriptionDiv = document.createElement("div");
    subDescriptionDiv.id = subDescriptionId;
    subDescriptionDiv.className = "otfem";
    subDescriptionDiv.classList.add("subDesc");
    subDescriptionDiv.innerHTML = richText(ingredientData.fields.keyIngredientSubDescription.content);

    subContainer.appendChild(subDescriptionDiv);

    if (ingredientData.fields.keyIngredientSubImage) {
        const subImage = await fetchImage(ingredientData.fields.keyIngredientSubImage);
        const imageElement = document.createElement("img");
        imageElement.src = subImage.fields.file.url;
        imageElement.alt = subImage.fields.description || "Key Ingredient Image";
        imageElement.className = "keyIngredientImage";
        subContainer.insertBefore(imageElement, subContainer.firstChild);
    }

    ingredientSpan.appendChild(titleDiv);
    ingredientSpan.appendChild(descriptionDiv);
    ingredientSpan.appendChild(subContainer);

    const container = index % 2 === 0 ? document.getElementById("keyIngredientsLeft") : document.getElementById("keyIngredientsRight");
    if (container) {
        container.appendChild(ingredientSpan);
        container.classList.remove("skeleton_text");
    }
}

function createImage(container, asset, className){
    const cont = document.getElementById(container);
    if (cont) {
        const image = document.createElement("img")
        image.src = asset.fields.file.url;
        image.alt = asset.fields.description;
        image.className = className;
        cont.appendChild(image);

    }
}

function updateImage(id, asset) {
    const elem = document.getElementById(id);
    if (elem) {
        elem.setAttribute("src", asset.fields.file.url);
        elem.setAttribute("alt", asset.fields.description);
        elem.style.opacity = "1";
    }
}


async function getContentfulCore() {
   const apiUrl = `https://apiapi.ombligo.com/n_contentful/specific/serversBySolutionSdp/collectionSlug/${collectionHandle}/`;

   fetch(apiUrl)
   .then(response => response.json())
   .then(data => {
       const contentfulFields = data.items[0].fields;
       processContentfulLazily(contentfulFields);
       const tectTalkContextTitle = data.items[0].fields.techTalkContextTitle;
       let techTalkContext = richText(data.items[0].fields.techTalkContext.content);
       retrieveLinkedTechTalks(data.items[0].fields.techTalks);

       fillTitleText(tectTalkContextTitle, '#CTOContentTitle');
       fillDescriptionText(techTalkContext, '#CTOContentDescription');
   });
}

function capitalize(s){
    return s && String(s[0]).toUpperCase() + String(s).slice(1);
}

function killLoading() {
    const tsi = document.getElementById("title-select-images");
    const vit = document.getElementById("version-into-text");

    if (tsi) {
        tsi.classList.remove('loadingCont');
    }
    if (vit) {
        vit.classList.remove('loadingCont');
    }

}

async function getMainConfig() {
    collectionHandle = capitalize(collectionHandle);
    let cacheKey = "sbsConf" + collectionHandle;

    if (Date.now() - localStorage.getItem('sbsConfLastUpdated') > 300000){ // 5 minutes
        localStorage.removeItem(cacheKey);
    }
  if(localStorage.getItem(cacheKey) && localStorage.getItem(cacheKey) !== null && localStorage.getItem(cacheKey).trim() !== ""){
    let resp = JSON.parse(localStorage.getItem(cacheKey));
    return resp;
  }

    const url = 'https://apiapi.ombligo.com/SBSCategoryMainConfig?category=' + collectionHandle;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        let data = await response.json();
        if (Array.isArray(data) && data.length > 0) {
            data = data[0] 
        }
        localStorage.setItem("sbsConf" + collectionHandle, JSON.stringify(data));
        localStorage.setItem('sbsConfLastUpdated', Date.now());

        return data;
    } catch (error) {
        console.error('Failed to fetch main config:', error);
    }
};

function createElement(tag, className, innerHTML = '', attributes = {}) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (innerHTML) element.innerHTML = innerHTML;
    Object.keys(attributes).forEach(key => element.setAttribute(key, attributes[key]));
    return element;
}

function createSpecBubble(spec = "N/A", desc, extended, childID) {
    let existingBubbles = document.querySelectorAll(".imageSpecBubble");
    let left = 10;
    if (existingBubbles.length > 0){
        left = (existingBubbles.length * 85) + 15;
    }

    let bubble = createElement('div', 'imageSpecBubble', null, {
        id: childID,
    });

    let mainSpec = createElement('div', 'mainSpec', spec);
    let descSpec = createElement('div', 'descSpec', desc);
    let imageSpecBubbleSpecContainer = createElement('div', 'imageSpecBubbleSpecContainer', null);

    let imageSpecBubbleSpecDetailContainer = createElement('div', 'imageSpecBubbleSpecDetailContainer', extended);

    bubble.style.left = left + "px";
    imageSpecBubbleSpecContainer.appendChild(mainSpec);
    imageSpecBubbleSpecContainer.appendChild(descSpec);
    bubble.appendChild(imageSpecBubbleSpecContainer);
    bubble.appendChild(imageSpecBubbleSpecDetailContainer);

    return bubble;
}

function createSpecElem(spec = "N/A", desc, extended, childID) {
    let existingElems = document.querySelectorAll(".specElem");
    let left = 0;
    let specElem = createElement('div', 'specElem', null, {
        id: childID,
    });
    let specElemSpecDetailContainer = createElement('div', 'TextSpecDetailContainer', extended);

    specElem.style.left = left + "px";

    specElem.appendChild(specElemSpecDetailContainer);

    return specElem;
}

async function getContentfulSBBPDP(sku) {
    const apiUrl = `https://apiapi.ombligo.com/n_contentful/specific/SBBPDPInfo/sku/${sku}/`;

    try {
        const response = await fetch(apiUrl);
        const data = await response.json();
        return data;
    } catch (error) {
        console.log('Likely No Data:', error);
    }
}


async function setupPDPCard() {
    let server = await getMainConfig();
    let shopProd = await fetchProdByHandle(server.chassis.sku)

    const versionTitle = document.getElementById("version-title")
    const versionInfo = document.getElementById("version-info");
    const versionInfoImages = document.getElementById("version-info-images");
    const versionInfoTitle = document.getElementById("version-info-title");
    const versionInfoDescription = document.getElementById("cto-build-summary");    
    const PriceAndBuy = document.getElementById("PriceAndBuy");
    const namedBabyDescription = document.getElementById("namedBabyDescription");
    const textSpecContainer = document.getElementById("textSpecContainer");

    try{
        let serverSKUDesc = await getContentfulSBBPDP(server.chassisSku);
        serverSKUDesc = serverSKUDesc.items[0].fields;
        const parsedDescription = serverSKUDesc.description.content.map(node => parseRichText(node)).join('');
        namedBabyDescription.innerHTML = parsedDescription;
    } catch (e) {
        console.log(`Content e ${e}`);
    }
    if (server && server.chassis) {
        versionTitle.textContent = versionTitle.textContent +  server.chassis.title;
    }
    const versionInfoMainImageContainer = document.getElementById("version-info-image-container");
    killLoading();
    updateImage("version-info-image", {
        fields: {
            file: {
                url: shopProd?.images?.[0]?.url.replace("_200x", "_600x") || 'https://onlineimages.techmikeny.com/oimages/generic/ics.png'
            },
            description: shopProd?.images?.[0]?.altText || 'Image coming soon'
        }
    });

    updateImage("version-info-image-modelLine", {
        fields: {
            file: {
                url: shopProd?.images?.[0]?.url.replace("_200x", "_600x") || 'https://onlineimages.techmikeny.com/oimages/generic/ics.png'
            },
            description: shopProd?.images?.[0]?.altText || 'Image coming soon'
        }
    });

    let bubbleContainer = createElement("div", "imageSpecBubbleContainer", null, {
        id: "imageSpecBubbleContainer"
    })

    versionInfoMainImageContainer.appendChild(bubbleContainer);

    let thumbnails = []
    if (shopProd && shopProd.images) {
        shopProd.images.forEach(image => {
            thumbnails.push(image.url);
        });
    }
    const thumbnailsContainer = createThumbnails(thumbnails);

    versionInfoImages.appendChild(thumbnailsContainer);

    const tableContainer = document.createElement('div');
    tableContainer.classList.add('mikes-pick-table-container');
    tableContainer.classList.add('category-spec-table-container')
    const table = document.createElement('table');
    table.classList.add('mikes-pick-table');
    table.classList.add('category-spec-table');
    const tbody = document.createElement('tbody');
    tbody.id = `mainCnfTable`;


    try{
        if (server.processor && server.processor.qty && server.processor.title) {
            tbody.appendChild(createTr('Processor', `${server.processor.qty}x ${server.processor.title}`));

            let bubble = createSpecBubble(`${server.processor.descVal[1].replace("GHz","")}`, 'GHz', `${server.processor.descVal[1]} across ${parseInt(server.processor.descVal[0]) * parseInt(server.processor.qty)}C.`);

            bubbleContainer.appendChild(bubble);
            if (namedBabyDescription.children > 1) namedBabyDescription.classList.add("dontOverwrite");
            let specElem;
            if (server.chassis.descVal["max-cores"]) {
              specElem = createSpecElem(`${server.processor.descVal[1].replace("GHz","")}`, 'GHz', `${server.processor.descVal[1]} across ${parseInt(server.processor.descVal[0]) * parseInt(server.processor.qty)} Cores <span class = "chassisMax">(Up to ${server.chassis.descVal["max-cores"]}x cores)</span>`);

            } else {
              specElem = createSpecElem(`${server.processor.descVal[1].replace("GHz","")}`, 'GHz', `${server.processor.descVal[1]} across ${parseInt(server.processor.descVal[0]) * parseInt(server.processor.qty)} Cores.`);
            }
            textSpecContainer.appendChild(specElem);
        }
        if (server.ram && server.ram.qty && server.ram.title){
             tbody.appendChild(createTr('RAM', `${server.ram.qty}x ${server.ram.title}`));
             let descVal = (parseInt(server.ram.descVal[0].replace("GB","")) * parseInt(server.ram.qty));
             let bubble2 = createSpecBubble(`${descVal} `, 'GB', `${descVal} across ${server.ram.qty}x DIMMs`);
             bubbleContainer.appendChild(bubble2);
             let specElem2;
             if (server.chassis.descVal["max-ram"]) {
               specElem2 = createSpecElem(`${ descVal} `, 'GB', `${descVal}GB across ${server.ram.qty}x DIMMs  <span class = "chassisMax"> (Up to ${(parseInt(server.chassis.descVal["max-ram"]) / 1000).toFixed(0) }TB RAM)</span>`);
             } else {
              specElem2 = createSpecElem(`${ descVal} `, 'GB', `${descVal}GB across ${server.ram.qty}x DIMMs`);
             }
             textSpecContainer.appendChild(specElem2);
        }
        if (server.raid && server.raid.qty && server.raid.title)  tbody.appendChild(createTr('RAID', `${server.raid.qty}x ${server.raid.title}`));
        if (server.storage && server.storage.qty && server.storage.title){
            tbody.appendChild(createTr('Storage', `${server.storage.qty}x ${server.storage.title}`));
            if (server.storage.descVal){
              if(server.storage.descVal["raw_storage_TB"]){
                let bubble3 = createSpecBubble(`${server.storage.descVal["raw_storage_TB"]}`, 'TB', `${server.storage.descVal["raw_storage_TB"]}TB across ${server.storage.qty} drives.`);
                bubbleContainer.appendChild(bubble3);
                let specElem3 ;
                if (server.chassis.descVal['max-storage']){
                  specElem3 = createSpecElem(`  `, 'GB', `${server.storage.descVal["raw_storage_TB"]}TB across ${server.storage.qty}x drives<span class = "chassisMax"> (Up to ${(parseInt(server.chassis.descVal["max-storage"]) / 1000).toFixed(2) }TB)</span>`);
                } else {
                  specElem3 = createSpecElem(`  `, 'GB', `${server.storage.descVal["raw_storage_TB"]}TB across ${server.storage.qty}x drives`);
                }
                textSpecContainer.appendChild(specElem3);

              }
            }
        }
       
        if (server.dcrd && server.dcrd.qty && server.dcrd.title) {
            tbody.appendChild(createTr('NDC', `${server.dcrd.qty}x ${server.dcrd.title}`));
        }
        if (server.rail && server.rail.qty && server.rail.title) tbody.appendChild(createTr('Rail', `${server.rail.qty}x ${server.rail.title}`));
        if (server.bzl && server.bzl.qty && server.bzl.title) {
            tbody.appendChild(createTr('Bezel', `${server.bzl.qty}x ${server.bzl.title}`));
        }
        if (server.boss && server.boss.qty && server.boss.title){
            tbody.appendChild(createTr('BOSS Card', `${server.boss.qty}x ${server.boss.title}`));
            tbody.appendChild(createTr('BOSS Drives', `${server.bossDrives.qty}x ${server.bossDrives.title}`));

        }
        if(server.gpu && server.gpu.qty && server.gpu.title){
            tbody.appendChild(createTr('GPU', `${server.gpu.qty}x ${server.gpu.title}`));
            let bubble4 = createSpecBubble(`${server.gpu.descVal[0]}`, `${server.gpu.descVal[1]}`, `${server.gpu.descVal[0]} ${server.gpu.descVal[1]} VRAM.`);
            bubbleContainer.appendChild(bubble4);

        }
        if (server.chassis && server.chassis.title.toLowerCase().includes("dell")){
            let specElem4 = createSpecElem(`${server.dcrd.descVal}`, 'GBPs', `iDRAC Enterprise Management`);
            textSpecContainer.appendChild(specElem4);
        }
    } catch (e) {
        console.log(`And E is... ${e}`);
    } 
    table.appendChild(tbody);
    tableContainer.appendChild(table);
    versionInfoDescription.appendChild(tableContainer);

    const priceContainer = createElement("div", "version-spec-info-price", parseFloat(server.chassis.price.toFixed(2)).toLocaleString('en-US', { style: 'currency', currency: 'USD' }));
    PriceAndBuy.appendChild(priceContainer);

    const configureButton = createElement('div', 'mcc-configure-button action-configure', `
        <svg class="md-chass-configure-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#fff">
            <path d="m620-284 56-56q6-6 6-14t-6-14L540-505q4-11 6-22t2-25q0-57-40.5-97.5T410-690q-17 0-34 4.5T343-673l94 94-56 56-94-94q-8 16-12.5 33t-4.5 34q0 57 40.5 97.5T408-412q13 0 24.5-2t22.5-6l137 136q6 6 14 6t14-6ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/>
        </svg>View Configuration`);
    configureButton.addEventListener("click", () => {
        localStorage.setItem("build", JSON.stringify(server))
        window.location.href = `${window.location.origin}/products/${server.chassis.sku}/modify`;
    });
    PriceAndBuy.appendChild(configureButton);

    contentfulDatas(shopProd.sku);

    let sbbModel = "R740";
    if (shopProd && String(shopProd.sku).includes("R640")) {
        sbbModel = "R640";
    }
    if (shopProd && String(shopProd.sku).includes("E560")) {
        sbbModel = "E560F";
    }
    if (shopProd && String(shopProd.sku).includes("R540")) {
        sbbModel = "R540";
    }
    if (shopProd && String(shopProd.sku).includes("XC740xd")) {
        sbbModel = "R740";
    }
    if (shopProd && String(shopProd.sku).includes("R440")) {
        sbbModel = "R440";
    }
    if (shopProd && String(shopProd.sku).includes("DL380")) {
        sbbModel = "DL380";
    }
    let sbbBlock = await getContentfulSpecificType("productLineBlock", "model", sbbModel);
    processContentfulLazily(sbbBlock.items[0].fields);
    if (server && server !== undefined && shopProd && shopProd !== undefined) generateStructuredData(server, shopProd);
    killLoading();
}

function checkURLStatus(url) {
  return new Promise((resolve) => {
    const xhr = new XMLHttpRequest();
    xhr.open('HEAD', url);

    xhr.onload = function() {
      if (xhr.status === 404) {
        resolve(true); 
      } else {
        resolve(false);
      }
    };

    xhr.onerror = function() {
       resolve(true); 
    };
    
    xhr.send();
  });
}


async function viewProductLine(){
  let cacheKey = "sbsConf" + collectionHandle;
  const server = localStorage.getItem(cacheKey);
  const sbbURL = JSON.parse(server).chassis.url;
  const is404 = await checkURLStatus(window.location.origin + sbbURL);
  if (!is404) window.location.href = sbbURL;
  if (is404)  window.location.href = '/collections/configure-to-order-servers';

}


async function generateStructuredData(server, shopProd) {
    let namedBabyDescription = document.getElementById("namedBabyDescription");
    let namedBabyDescriptionText = namedBabyDescription.innerText;
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": server.chassis.title || collectionHandle,
        "image": shopProd.images[0].url.replace("_200x", "_600x"), // Use the high-res image URL
        "description": namedBabyDescriptionText || "Detailed description of the server",
        "brand": {
            "@type": "Brand",
            "name": "Dell"
        },
        "sku": server.chassis.sku.substring(0, 49),
        "offers": {
            "@type": "Offer",
            "url": window.location.href,
            "priceCurrency": "USD",
            "price": parseFloat(server.chassis.price.toFixed(2)),
            "priceValidUntil": "2025-12-31",
            "itemCondition": "https://schema.org/NewCondition",
            "availability": "https://schema.org/InStock",
            "seller": {
                "@type": "Organization",
                "name": "TechMikeNY"
            }
        },
        "productDetails": {
            "cpu": {
                "@type": "PropertyValue",
                "name": "CPU",
                "value": `${server.processor.qty}x ${server.processor.title} ${server.processor.speed}`
            },
            "ram": {
                "@type": "PropertyValue",
                "name": "RAM",
                "value": `${server.ram.qty}x ${server.ram.title}`
            },
            "storage": {
                "@type": "PropertyValue",
                "name": "Storage",
                "value": `${server.storage.qty}x ${server.storage.title}`
            }
        }
    };

    // Inject the structured data into the page as a script tag
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.innerHTML = JSON.stringify(schemaData);
    document.head.appendChild(script);
}





function clearOtherServers(){
    document.getElementById("otherBuilds").remove();
}

document.addEventListener('DOMContentLoaded', function() {
    const recentBuildsContainer = document.getElementById('recentBuildsContainer');

    let allServers = [];
    
    const fetchServers = async () => {
        try {
            recentBuildsContainer.innerHTML = `
                <div class="loading">
                    <div class="spinner"></div>
                </div>
            `;
            const currentUrl = window.location.origin + window.location.pathname;
            
            const response = await fetch(currentUrl + '/products.json');

            if (!response.ok) throw new Error('Network response was not ok');
            
            const data = await response.json();
            const availableProducts = data.products.filter(product => {
                const variants = product.variants || [];
                return variants.some(variant => variant.available === true)
            });
            
            if (availableProducts.length === 0) {
                console.warn('No available products found');
                clearOtherServers()
            }

            allServers = transformProductData(availableProducts);
            
            addStructuredData(allServers);
            
            displayRecentBuilds(allServers.slice(0, 10));
        } catch (error) {
            console.error('Error fetching products:', error);
            recentBuildsContainer.innerHTML = `
                <div class="error-message">
                    Failed to load recent builds. Please try again later.
                </div>
            `;
            
            clearOtherServers()

        }
    };
    
    const transformProductData = (products) => {
        return products.map(product => {
            const mainVariant = product.variants[0] || {};
            
            let cpuCores = 10;
            let ramCapacity = 32; 
            
            const coreTag = product.tags.find(tag => tag.startsWith('no_cores='));
            if (coreTag) {
                const coreValue = coreTag.split('=')[1];
                if (coreValue) cpuCores = coreValue;
            }
            
            const ramTag = product.tags.find(tag => tag.startsWith('total_mem_cap='));
            const totalMemTag = product.tags.find(tag => tag.startsWith('totmemory='));
            
            if (ramTag) {
                const ramValue = ramTag.split('=')[1];
                if (ramValue) {
                    ramCapacity = parseInt(ramValue);
                }
            } else if (totalMemTag) {
                const ramValue = totalMemTag.split('=')[1];
                if (ramValue) {
                    ramCapacity = parseInt(ramValue);
                }
            }
            

            if (cpuCores === 10 && product.body_html) {
                const coreMatch = product.body_html.match(/(\d+)x\s*Cores/i);
                if (coreMatch) cpuCores = coreMatch[1];
            }
            
            if (!ramCapacity && product.body_html) {
                const ramMatch = product.body_html.match(/(\d+)GB\s*Memory/i);
                if (ramMatch) ramCapacity = ramMatch[1];
            }
            
            return {
                build_name: mainVariant.sku || product.title,
                chassis_alt: product.title,
                chassis_cto_title: product.title,
                chassis_handle: product.handle,
                chassis_image: product.images && product.images.length > 0 ? product.images[0].src : '',
                created_at: product.published_at,
                cto_id: mainVariant.id || '',
                variant_id: mainVariant.id || '', // Add variant ID for cart
                number_of_cores: cpuCores,
                order_id: mainVariant.id || '',
                product_url: `https://techmikeny.com/products/${product.handle}`,
                ram_capacity: ramCapacity,
                price: mainVariant.price,
                description: product.body_html,
                brand: 'TechMike NY',
                category: 'Server Hardware',
                availability: mainVariant.available ? 'InStock' : 'OutOfStock',
                condition: 'NewCondition',
                available: mainVariant.available || false // Add availability flag
            };
        });
    };
    
    const addStructuredData = (products) => {
        const solutionTitle = document.getElementById('solution').innerText;
        const existingScript = document.getElementById('product-structured-data');
        if (existingScript) {
            existingScript.remove();
        }

        const structuredData = {
            "@context": "https://schema.org",
            "@type": "ItemList",
            "name":  solutionTitle + " Server Builds - TechMikeNY",
            "description": `Latest available ${solutionTitle} builds and custom configurations`,
            "numberOfItems": products.length,
            "itemListElement": products.map((product, index) => ({
                "@type": "ListItem",
                "position": index + 1,
                "item": {
                    "@type": "Product",
                    "@id": product.product_url,
                    "name": product.chassis_cto_title,
                    "description": product.description || `${product.number_of_cores} CPU cores server with ${product.ram_capacity}GB RAM`,
                    "brand": {
                        "@type": "Brand",
                        "name": product.brand
                    },
                    "category": product.category,
                    "image": product.chassis_image,
                    "url": product.product_url,
                    "sku": product.build_name,
                    "offers": {
                        "@type": "Offer",
                        "price": product.price,
                        "priceCurrency": "USD",
                        "availability": `https://schema.org/${product.availability}`,
                        "itemCondition": `https://schema.org/${product.condition}`,
                        "seller": {
                            "@type": "Organization",
                            "name": "TechMikeNY",
                            "url": "https://techmikeny.com"
                        }
                    },
                    "additionalProperty": [
                        {
                            "@type": "PropertyValue",
                            "name": "CPU Cores",
                            "value": product.number_of_cores
                        },
                        {
                            "@type": "PropertyValue",
                            "name": "RAM Capacity",
                            "value": `${product.ram_capacity}GB`
                        }
                    ]
                }
            }))
        };
        
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.id = 'product-structured-data';
        script.textContent = JSON.stringify(structuredData, null, 2);
        document.head.appendChild(script);
        
    };
    
    const getProductTitleFromVariant = (variantId) => {
        const product = allServers.find(server => server.variant_id == variantId);
        return product ? product.chassis_cto_title : '';
    };

    const addToCart = async (variantId, quantity = 1) => {
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: variantId,
                        quantity: quantity
                    }]
                })
            });

            if (!response.ok) {
                throw new Error('Failed to add item to cart');
            }

            const result = await response.json();
            
            showCartMessage('Item added to cart successfully!', 'success', getProductTitleFromVariant(variantId));
            
            updateCartCount();
            
            return result;
        } catch (error) {
            console.error('Error adding to cart:', error);
            showCartMessage('Failed to add item to cart. Please try again.', 'error');
            throw error;
        }
    };

    const showCartMessage = (message, type = 'success', productTitle = '') => {


        if (type === 'success') {
            Swal.fire({
                icon: 'success',
                title: 'Added to Cart!',
                text: productTitle ? `${productTitle} has been added to your cart.` : message,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                showCloseButton: true,
                customClass: {
                    popup: 'colored-toast'
                }
            });

        } else {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: message,
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                showCloseButton: true,
                customClass: {
                    popup: 'colored-toast'
                }
            });
        }
    };

    const updateCartCount = async () => {
        try {
            const response = await fetch('/cart.js');
            const cart = await response.json();
            
            const cartCountElement = document.querySelector('#desktop-cart-li a ');
            cartCountElement.innerHTML = `<span class="material-icons-outlined navbar-icon">
                  shopping_cart
                </span> ${ cart.item_count}`
            
        } catch (error) {
            console.error('Error updating cart count:', error);
        }
    };
    
    function displayRecentBuilds(builds) {
        if (!builds || builds.length === 0) {
            recentBuildsContainer.innerHTML = `
                <div class="no-results">
                    No recent builds found.
                </div>
            `;
            return;
        }
        
        recentBuildsContainer.innerHTML = '';
        
        builds.forEach(build => {
            const card = createBuildCard(build);
            recentBuildsContainer.appendChild(card);
        });
    }
    

    function createBuildCard(build) {
        const card = document.createElement('div');
        card.className = 'server-product-card';
        card.classList.add('large-card');
        
        const productUrl = `https://techmikeny.com/products/${build.chassis_handle}`;
        
        // Add microdata attributes to the card for additional structured data
        card.setAttribute('itemscope', '');
        card.setAttribute('itemtype', 'https://schema.org/Product');
        
        let html = '';
        
        html += `
            <div class="spinner-overlay">
                <div class="spinner"></div>
            </div>
            <div class="server-product-content">
                <a class="server-product-link" href="${productUrl}" title="${build.chassis_cto_title}" itemprop="url">
                    <meta itemprop="name" content="${build.chassis_cto_title}">
                    <meta itemprop="sku" content="${build.build_name}">
                    <meta itemprop="brand" content="TechMike NY">
                    <meta itemprop="category" content="Server Hardware">
                    ${build.description ? `<meta itemprop="description" content="${build.description}">` : ''}
                    
                    <div class="server-product-image">
                        ${build.chassis_image ? 
                            `<img src="${build.chassis_image}" alt="${build.chassis_cto_title}" height="190px" class="collection_product_card_img" itemprop="image">` : 
                            '<img src="https://onlineimages.techmikeny.com/oimages/generic/ics.png" class="collection_product_card_img" alt="Product Image Coming Soon" height="190px" itemprop="image">'}
                    </div>
                    <div class="collection_product_card_title" itemprop="name">${build.chassis_cto_title || 'Custom Server'}</div>
                    ${build.price ? 
                        `<div class="collection_product_card_price" itemscope itemtype="https://schema.org/Offer">
                            <meta itemprop="price" content="${build.price}">
                            <meta itemprop="priceCurrency" content="USD">
                            <meta itemprop="availability" content="https://schema.org/${build.availability}">
                            ${parseFloat(build.price).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
                        </div>` : ''}
                    <p id="productDescription" class="collection_product_card_desc" itemprop="description" style="margin-top: 10px; margin-bottom: 10px;"> 
                        ${build.description ? build.description : `${build.number_of_cores} CPU cores server with ${build.ram_capacity}GB RAM`} 
                    </p>
                </a>
                
                <div class="product-card-actions not-rec" >
                    ${build.available && build.variant_id ? 
                        `<button class="add-to-cart-btn btn 
                            product-form__cart-submit 
                            collection_product_card_add_2_cart_btn" 
                                data-variant-id="${build.variant_id}" 
                                data-product-title="${build.chassis_cto_title}"
                                style="
                                    max-width: 100% !important;
                                    width: 100% !important;
                                    margin-top: 0px !important;
                                    margin-bottom: 8px !important;
                                    "
                                onmouseover="this.style.backgroundColor='#0056b3'"
                                onmouseout="this.style.backgroundColor='#007bff'"
                                >
                            <span class="btn-text">Add to Cart</span>
                            <span class="btn-spinner" style="display: none;">
                                <span style="display: inline-block; width: 16px; height: 16px; border: 2px solid #ffffff; border-radius: 50%; border-top-color: transparent; animation: spin 1s linear infinite;"></span>
                                Adding...
                            </span>
                        </button>` 
                        : 
                        `<button class="add-to-cart-btn
                            btn 
                            product-form__cart-submit 
                            collection_product_card_add_2_cart_btn
                        " 
                                disabled 
                                >
                            Out of Stock
                        </button>`
                    }
                    
                    <a href="${productUrl}" 
                       class="view-details-btn"
                       style="
                           display: block;
                           width: 100%;
                           padding: 10px 20px;
                           background-color: transparent;
                           color: #0095ff;
                           border: 2px solid #0095ff;
                           border-radius: 5px;
                           text-align: center;
                           text-decoration: none;
                           font-size: 14px;
                           font-weight: bold;
                           transition: all 0.3s ease;
                           box-sizing: border-box;
                       "
                       onmouseover="this.style.backgroundColor='#007bff'; this.style.color='white';"
                       onmouseout="this.style.backgroundColor='transparent'; this.style.color='#007bff';">
                        View Details
                    </a>
                </div>
            </div>
        `;
        
        card.innerHTML = html;

        if (build.description) {
            const descriptionElement = card.querySelector('#productDescription');
            if (descriptionElement) {
                descriptionElement.innerHTML = build.description;
            }
        }
        
        const addToCartBtn = card.querySelector('.add-to-cart-btn');
        if (addToCartBtn && !addToCartBtn.disabled) {
            addToCartBtn.addEventListener('click', async function(e) {
                e.preventDefault();
                e.stopPropagation();
                
                const variantId = this.getAttribute('data-variant-id');
                const productTitle = this.getAttribute('data-product-title');
                const btnText = this.querySelector('.btn-text');
                const btnSpinner = this.querySelector('.btn-spinner');
                
                btnText.style.display = 'none';
                btnSpinner.style.display = 'inline-block';
                this.disabled = true;
                
                try {
                    await addToCart(variantId, 1);
                } catch (error) {
                    console.error('Failed to add to cart:', error);
                } finally {
                    // Reset button state
                    btnText.style.display = 'inline-block';
                    btnSpinner.style.display = 'none';
                    this.disabled = false;
                }
            });
        }

        const link = card.querySelector('.server-product-link');
        const spinnerOverlay = card.querySelector('.spinner-overlay');
        
        link.addEventListener('click', function(e) {
            e.preventDefault();
            spinnerOverlay.classList.add('active');
            
            window.location.href = this.href;
        });
        
        return card;
    }



    fetchServers();
});